const lazyloadHelper = require('norska/frontend/algolia/lazyload');
const _ = require('lodash');
const helper = require('./helper.js');
const marked = require('marked');

module.exports = {
  credentials: {
    appId: 'O3F8QXYK6R',
    apiKey: '3e35bfd377d42d92179ab5b47efe5a6c',
    indexName: 'gamemaster_items',
  },
  sidebar: [
    {
      title: 'Subreddit',
      options: {
        attribute: 'subreddit',
      },
    },
    {
      title: 'Type',
      options: {
        attribute: 'type',
      },
    },
    {
      title: 'Rarity',
      options: {
        attribute: 'rarity.numeric',
        sortBy: ['name:asc'],
        transformItems(items) {
          return items.map((item) => {
            item.highlighted = helper.numericRarityToTextual(item.value);
            return item;
          });
        },
      },
    },
    {
      title: 'Attunement',
      options: {
        attribute: 'requiresAttunement',
      },
    },
  ],
  transforms: {
    cssRarity(item) {
      const slug = _.chain(item)
        .get('rarity.textual', 'Unknown')
        .camelCase()
        .value();
      return `bg-${slug}`;
    },
    markdown(item) {
      return marked(item.description);
    },
    img(item) {
      const originUrl = item.picture.url;
      const options = {
        imoen: item.picture,
        uuid: item.objectID,
        cacheBusting: false,
      };
      const img = lazyloadHelper.attributes(originUrl, options);

      return img;
    },
  },
};
